export default __webpack_public_path__ + "static/media/syncCompletedForTables.6ae1f665.svg";